module.exports = __webpack_public_path__ + "img/list_Character_sq_25.72705ea2.jpeg";